import { StatusMessage } from 'app/agriculture/routes/Devices/utils/status/types';

export function aggregateStatusMessages(statusMessages: StatusMessage[]): StatusMessage {
    if (statusMessages.length === 0) {
        return { status: 'unknown', messages: [] };
    }

    const messages = statusMessages.flatMap(({ messages }) => messages);

    if (statusMessages.some(({ status }) => status === 'loading')) {
        return { status: 'loading', messages };
    }

    if (statusMessages.some(({ status }) => status === 'error')) {
        return { status: 'error', messages };
    }

    if (statusMessages.some(({ status }) => status === 'expectedError')) {
        return { status: 'expectedError', messages };
    }

    if (statusMessages.some(({ status }) => status === 'warning')) {
        return { status: 'warning', messages };
    }

    if (statusMessages.some(({ status }) => status === 'success')) {
        return { status: 'success', messages };
    }

    return { status: 'unknown', messages };
}
